/**
 * Vite 浏览器端无 Node `process`；共享 lib 仍读 process.env。
 * 须在其它入口 import 之前加载。
 */
type SpaProcess = { env: Record<string, string | undefined> };

const g = globalThis as typeof globalThis & { process?: SpaProcess };

if (!g.process?.env) {
  g.process = { env: { ...(g.process?.env || {}) } };
}

const injected = {
  NODE_ENV: process.env.NODE_ENV,
  NEXT_PUBLIC_IMAGE_CDN_BASE_URL: process.env.NEXT_PUBLIC_IMAGE_CDN_BASE_URL,
  IMAGE_CDN_BASE_URL: process.env.IMAGE_CDN_BASE_URL,
  NEXT_PUBLIC_ASSET_PREFIX: process.env.NEXT_PUBLIC_ASSET_PREFIX,
  ASSET_PREFIX: process.env.ASSET_PREFIX,
};

for (const [key, value] of Object.entries(injected)) {
  if (value != null && value !== '' && g.process.env[key] == null) {
    g.process.env[key] = value;
  }
}
